import React from "react";
import store from "./store/store";
import { Provider } from "react-redux";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache, defaultDataIdFromObject } from "apollo-cache-inmemory";
import { API_HOST } from "./utils/constants";
import Main from "./Main";

const link = createHttpLink({
  uri: `${API_HOST}/graphql`,
  credentials: "include",
});

export const DShopClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    dataIdFromObject: (object) => {
      switch (object.__typename) {
        case "FilteredProductsGraphqlAmountxRegionViewRow":
          return `${object.id}_${object.region_tid}`;
        default:
          return defaultDataIdFromObject(object);
      }
    },
  }),
});

const App = () => {
  return (
    <Provider store={store}>
      <ApolloProvider client={DShopClient}>
        <Main />
      </ApolloProvider>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js